export const dataAyuntamientos20232024 = [
  {
    id: 1,
    titleItem: "2024_SEE_AYUN_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_AYUN_TLAX_MUN.xlsx",
  },
  {
    id: 2,
    titleItem: "2024_SEE_AYUN_TLAX_MUNCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_AYUN_TLAX_MUNCAND.xlsx",
  },
  {
    id: 3,
    titleItem: "2024_SEE_AYUN_TLAX_MUNPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_AYUN_TLAX_MUNPP.xlsx",
  },
  {
    id: 4,
    titleItem: "2024_SEE_AYUN_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_AYUN_TLAX_SEC.xlsx",
  },
  {
    id: 5,
    titleItem: "2024_SEE_AYUN_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_AYUN_TLAX_CAS.xlsx",
  },
];
export const dataDiputaciones20232024 = [
  {
    id: 1,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_CAS.xlsx",
  },
  {
    id: 2,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DIS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_DIS.xlsx",
  },
  {
    id: 3,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DISCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_DISCAND.xlsx",
  },
  {
    id: 4,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DISPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_DISPP.xlsx",
  },
  {
    id: 5,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_MUN.xlsx",
  },
  {
    id: 6,
    titleItem: "2024_SEE_DIP_LOC_MR_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_DIP_LOC_MR_TLAX_SEC.xlsx",
  },
];
export const dataPresidenciasC20232024 = [
  {
    id: 1,
    titleItem: "2024_SEE_PRE_COM_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_PRE_COM_TLAX_CAS.xlsx",
  },
  {
    id: 2,
    titleItem: "2024_SEE_PRE_COM_TLAX_COM",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_PRE_COM_TLAX_COM.xlsx",
  },
  {
    id: 3,
    titleItem: "2024_SEE_PRE_COM_TLAX_COMCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_PRE_COM_TLAX_COMCAND.xlsx",
  },
  {
    id: 4,
    titleItem: "2024_SEE_PRE_COM_TLAX_COMPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_PRE_COM_TLAX_COMPP.xlsx",
  },
  {
    id: 5,
    titleItem: "2024_SEE_PRE_COM_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/2024_SEE_PRE_COM_TLAX_SEC.xlsx",
  },
];

// export const dataDiputaciones20232024 = [
//   {
//     id: 1,
//     titleItem: "2021_SEE_DIP_LOC_MR_TLAX_CAS",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/10.xlsx",
//   },
//   {
//     id: 2,
//     titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DIS",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/11.xlsx",
//   },
//   {
//     id: 3,
//     titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DISCAND",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/12.xlsx",
//   },
//   {
//     id: 4,
//     titleItem: "2024_SEE_DIP_LOC_MR_TLAX_DISPP",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/13.xlsx",
//   },
//   {
//     id: 5,
//     titleItem: "2024_SEE_DIP_LOC_MR_TLAX_MUN",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/14.xlsx",
//   },
//   {
//     id: 6,
//     titleItem: "2024_SEE_DIP_LOC_MR_TLAX_SEC",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/15.xlsx",
//   },
// ];

// export const dataAyuntamientos20232024 = [
//   {
//     id: 1,
//     titleItem: "2024_SEE_AYUN_TLAX_CAS",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/16.xlsx",
//   },
//   {
//     id: 2,
//     titleItem: "2024_SEE_AYUN_TLAX_MUN",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/17.xlsx",
//   },
//   {
//     id: 3,
//     titleItem: "2024_SEE_AYUN_TLAX_MUNCAND",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/18.xlsx",
//   },
//   {
//     id: 4,
//     titleItem: "2024_SEE_AYUN_TLAX_MUNPP",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/19.xlsx",
//   },
//   {
//     id: 5,
//     titleItem: "2024_SEE_AYUN_TLAX_SEC",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/20.xlsx",
//   },
// ];

// export const dataPresidencias20232024 = [
//   {
//     id: 1,
//     titleItem: "2024_SEE_PRE_COM_TLAX_CAS",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/21.xlsx",
//   },
//   {
//     id: 2,
//     titleItem: "2024_SEE_PRE_COM_TLAX_MUN",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/22.xlsx",
//   },
//   {
//     id: 3,
//     titleItem: "2024_SEE_PRE_COM_TLAX_MUNCAND",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/23.xlsx",
//   },
//   {
//     id: 4,
//     titleItem: "2024_SEE_PRE_COM_TLAX_MUNPP",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/24.xlsx",
//   },
//   {
//     id: 5,
//     titleItem: "2024_SEE_PRE_COM_TLAX_SEC",
//     typeDocument: "excel",
//     linkItem:
//       "https://itetlax.org.mx/assets/excel/procesosElect/PE20232024/25.xlsx",
//   },
// ];

export const dataResultadosE2021 = [
  {
    id: 1,
    titleItem: "2021_SEE_PRE_COM_TLAX_CAS_EXT",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PEE2021/1.xlsx",
  },
  {
    id: 2,
    titleItem: "2021_SEE_PRE_COM_TLAX_SEC_EXT",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PEE2021/2.xlsx",
  },
];

export const dataGubernatura20202021 = [
  {
    id: 1,
    titleItem: "2021_SEE_GOB_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/1.xlsx",
  },
  {
    id: 2,
    titleItem: "2021_SEE_GOB_TLAX_DIS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/2.xlsx",
  },
  {
    id: 3,
    titleItem: "2021_SEE_GOB_TLAX_DISCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/3.xlsx",
  },
  {
    id: 4,
    titleItem: "2021_SEE_GOB_TLAX_DISPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/4.xlsx",
  },
  {
    id: 5,
    titleItem: "2021_SEE_GOB_TLAX_ENT",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/5.xlsx",
  },
  {
    id: 6,
    titleItem: "2021_SEE_GOB_TLAX_ENTCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/6.xlsx",
  },
  {
    id: 7,
    titleItem: "2021_SEE_GOB_TLAX_ENTPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/7.xlsx",
  },
  {
    id: 8,
    titleItem: "2021_SEE_GOB_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/8.xlsx",
  },
  {
    id: 9,
    titleItem: "2021_SEE_GOB_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/9.xlsx",
  },
];

export const dataDiputaciones20202021 = [
  {
    id: 1,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/10.xlsx",
  },
  {
    id: 2,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_DIS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/11.xlsx",
  },
  {
    id: 3,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_DISCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/12.xlsx",
  },
  {
    id: 4,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_DISPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/13.xlsx",
  },
  {
    id: 5,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/14.xlsx",
  },
  {
    id: 6,
    titleItem: "2021_SEE_DIP_LOC_MR_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/15.xlsx",
  },
];

export const dataAyuntamientos20202021 = [
  {
    id: 1,
    titleItem: "2021_SEE_AYUN_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/16.xlsx",
  },
  {
    id: 2,
    titleItem: "2021_SEE_AYUN_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/17.xlsx",
  },
  {
    id: 3,
    titleItem: "2021_SEE_AYUN_TLAX_MUNCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/18.xlsx",
  },
  {
    id: 4,
    titleItem: "2021_SEE_AYUN_TLAX_MUNPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/19.xlsx",
  },
  {
    id: 5,
    titleItem: "2021_SEE_AYUN_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/20.xlsx",
  },
];

export const dataPresidencias20202021 = [
  {
    id: 1,
    titleItem: "2021_SEE_PRE_COM_TLAX_CAS",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/21.xlsx",
  },
  {
    id: 2,
    titleItem: "2021_SEE_PRE_COM_TLAX_MUN",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/22.xlsx",
  },
  {
    id: 3,
    titleItem: "2021_SEE_PRE_COM_TLAX_MUNCAND",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/23.xlsx",
  },
  {
    id: 4,
    titleItem: "2021_SEE_PRE_COM_TLAX_MUNPP",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/24.xlsx",
  },
  {
    id: 5,
    titleItem: "2021_SEE_PRE_COM_TLAX_SEC",
    typeDocument: "excel",
    linkItem:
      "https://itetlax.org.mx/assets/excel/procesosElect/PE20202021/25.xlsx",
  },
];

export const dataResultados2018 = [
  {
    id: 1,
    titleItem:
      "Tabla de resultados electorales por casilla de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/1.pdf",
  },
  {
    id: 2,
    titleItem:
      "Tabla de resultados electorales por distrito de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/2.pdf",
  },
  {
    id: 3,
    titleItem:
      "Tabla de resultados electorales por entidad de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/3.pdf",
  },
  {
    id: 4,
    titleItem:
      "Tabla de resultados electorales por municipio de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/4.pdf",
  },
  {
    id: 5,
    titleItem:
      "Tabla de resultados electorales por sección electoral de la elección de diputaciones electorales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/5.pdf",
  },
  {
    id: 6,
    titleItem:
      "Tabla de resultados electorales por candidatos de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/6.pdf",
  },
  {
    id: 7,
    titleItem:
      "Tabla de resultados electorales por partido político de la elección de diputaciones locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/procesosElect/PE2018/7.pdf",
  },
];

export const dataListadoCandidatos2016 = [
  {
    id: 1,
    titleItem: "Listado de Candidatos a Gobernador",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/23.pdf",
  },
  {
    id: 2,
    titleItem: "Listado de Candidatos a Diputados MR",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/24.pdf",
  },
  {
    id: 3,
    titleItem: "Listado de Candidatos RP",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/25.pdf",
  },
  {
    id: 4,
    titleItem: "Listado de Candidatos a Presidencias de Comunidad",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/26.pdf",
  },
];

export const dataResultadosSeccion2016 = [
  {
    id: 1,
    titleItem: "Resultados Gobernador por Sección",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/19.pdf",
  },
  {
    id: 2,
    titleItem: "Resultados Diputados por Sección",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/20.pdf",
  },
  {
    id: 3,
    titleItem: "Resultados Ayuntamientos por Sección",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/21.pdf",
  },
  {
    id: 4,
    titleItem: "Resultados de Presidencias de Comunidad por Sección",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/22.pdf",
  },
];

export const dataResultados2016 = [
  {
    id: 1,
    titleItem: "Resultados Gobernador",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/10.pdf",
  },
  {
    id: 2,
    titleItem: "Lista de candidatos a Diputados Locales MR",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/11.pdf",
  },
  {
    id: 3,
    titleItem: "Lista de candidatos Ayuntamientos",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/12.pdf",
  },
  {
    id: 4,
    titleItem: "Regidurías",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/13.pdf",
  },
  {
    id: 5,
    titleItem: "Resultados Diputados Locales MR",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/14.pdf",
  },
  {
    id: 6,
    titleItem: "Resultados Diputados Locales RP",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/15.pdf",
  },
  {
    id: 7,
    titleItem: "Resultados Ayuntamientos",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/16.pdf",
  },
  {
    id: 8,
    titleItem: "Listado de candidatos a presidencias de comunidad",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/17.pdf",
  },
  {
    id: 9,
    titleItem: "Resultados de Presidencias de Comunidad",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/18.pdf",
  },
];

export const dataCasillas2016 = [
  {
    id: 1,
    titleItem: "Lista de ubicación de casillas Distrito 1",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/5.pdf",
  },
  {
    id: 2,
    titleItem: "Lista de ubicación de casillas Distrito 2",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/6.pdf",
  },
  {
    id: 3,
    titleItem: "Lista de ubicación de casillas Distrito 3",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/7.pdf",
  },
  {
    id: 4,
    titleItem: "Lista de ubicación de casillas especiales",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/8.PDF",
  },
  {
    id: 5,
    titleItem:
      "Lista de ubicación de casillas de los municipios de Panotla, Totolac e Ixtacuixtla PELO 2018",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/9.pdf",
  },
];

export const dataEncuestas2016 = [
  {
    id: 1,
    titleItem: "Mayo ITE",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/3.pdf",
  },
  {
    id: 2,
    titleItem: "Gii360 Grupo Impacto",
    typeDocument: "pdf",
    linkItem:
      "https://itetlax.org.mx/assets/pdf/procesosElect/PE20152016/4.pdf",
  },
];

export const dataHistorial = [
  {
    id: 1,
    titleItem: "1995",
    flushID: "1995",
    children: [
      {
        id: 1,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/1.pdf",
      },
    ],
  },
  {
    id: 2,
    titleItem: "1996",
    flushID: "1996",
    children: [
      {
        id: 1,
        titleItem: "Elección Extraordinaria de los 16 municipios",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/2.pdf",
      },
    ],
  },
  {
    id: 3,
    titleItem: "1998",
    flushID: "1998",
    children: [
      {
        id: 1,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/3.pdf",
      },
      {
        id: 2,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/4.pdf",
      },
      {
        id: 3,
        titleItem: "Gobernador",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/5.pdf",
      },
      {
        id: 4,
        titleItem:
          "Integración de las formulas de diputados de representación proporcional",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/6.pdf",
      },
    ],
  },
  {
    id: 4,
    titleItem: "1999",
    flushID: "1999",
    children: [
      {
        id: 1,
        titleItem: "Elección extraordinaria de ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/7.pdf",
      },
    ],
  },
  {
    id: 5,
    titleItem: "2001",
    flushID: "2001",
    children: [
      {
        id: 1,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/8.pdf",
      },
      {
        id: 2,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/9.pdf",
      },
      {
        id: 3,
        titleItem:
          "Integración de las formulas de diputados de representación proporcional",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/10.pdf",
      },
    ],
  },
  {
    id: 6,
    titleItem: "2002",
    flushID: "2002",
    children: [
      {
        id: 1,
        titleItem: "Elección extraordinaria de ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/11.pdf",
      },
    ],
  },
  {
    id: 7,
    titleItem: "2004",
    flushID: "2004",
    children: [
      {
        id: 1,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/12.pdf",
      },
      {
        id: 2,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/13.pdf",
      },
      {
        id: 3,
        titleItem: "Gobernador",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/14.pdf",
      },
      {
        id: 4,
        titleItem:
          "Integración de las formulas de diputados de representación proporcional",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/15.pdf",
      },
    ],
  },
  {
    id: 8,
    titleItem: "2007",
    flushID: "2007",
    children: [
      {
        id: 1,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/16.pdf",
      },
      {
        id: 2,
        titleItem: "Diputados",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/17.pdf",
      },
      {
        id: 3,
        titleItem:
          "Integración de las formulas de diputados de representación proporcional",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/18.pdf",
      },
    ],
  },
  {
    id: 9,
    titleItem: "2010",
    flushID: "2010",
    children: [
      {
        id: 1,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/19.pdf",
      },
      {
        id: 2,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/20.pdf",
      },
      {
        id: 3,
        titleItem: "Gobernador",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/21.pdf",
      },
      {
        id: 4,
        titleItem:
          "Integración de las formulas de diputados de representación proporcional",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/22.pdf",
      },
    ],
  },
  {
    id: 10,
    titleItem: "2013",
    flushID: "2013",
    children: [
      {
        id: 1,
        titleItem:
          "Integración de las formulas de diputados de representación popular",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/23.pdf",
      },
      {
        id: 2,
        titleItem: "Elección extraordinaria pc",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/24.pdf",
      },
      {
        id: 3,
        titleItem: "Ayuntamientos",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/25.pdf",
      },
      {
        id: 4,
        titleItem: "Diputados MR",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/26.pdf",
      },
      {
        id: 5,
        titleItem: "Presidencias de comunidad",
        typeDocument: "pdf",
        linkItem:
          "https://itetlax.org.mx/assets/pdf/procesosElect/historial/27.pdf",
      },
    ],
  },
];
